// Federation logos (PNG data URLs) — used in PDF exports.
// These are simple, recognizable stylized circular badges in the federation colors.

// AIDA — purple/violet circular badge
export const AIDA_LOGO = 'data:image/svg+xml;base64,' + btoa(`<svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120">
  <defs>
    <radialGradient id="aidaGrad" cx="0.3" cy="0.3" r="0.8">
      <stop offset="0%" stop-color="#a855f7"/>
      <stop offset="100%" stop-color="#581c87"/>
    </radialGradient>
  </defs>
  <circle cx="60" cy="60" r="56" fill="url(#aidaGrad)" stroke="#fff" stroke-width="3"/>
  <text x="60" y="50" font-family="Helvetica,Arial,sans-serif" font-size="22" font-weight="bold" fill="white" text-anchor="middle">AIDA</text>
  <text x="60" y="78" font-family="Helvetica,Arial,sans-serif" font-size="10" font-weight="600" fill="#e9d5ff" text-anchor="middle">INTERNATIONAL</text>
  <path d="M30 90 Q60 95 90 90" stroke="#fff" stroke-width="2" fill="none" opacity="0.7"/>
</svg>`);

// CMAS — teal/blue circular badge (Confédération Mondiale des Activités Subaquatiques)
export const CMAS_LOGO = 'data:image/svg+xml;base64,' + btoa(`<svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120">
  <defs>
    <radialGradient id="cmasGrad" cx="0.3" cy="0.3" r="0.8">
      <stop offset="0%" stop-color="#14b8a6"/>
      <stop offset="100%" stop-color="#0c4a6e"/>
    </radialGradient>
  </defs>
  <circle cx="60" cy="60" r="56" fill="url(#cmasGrad)" stroke="#fff" stroke-width="3"/>
  <text x="60" y="50" font-family="Helvetica,Arial,sans-serif" font-size="22" font-weight="bold" fill="white" text-anchor="middle">CMAS</text>
  <text x="60" y="76" font-family="Helvetica,Arial,sans-serif" font-size="7" font-weight="600" fill="#a7f3d0" text-anchor="middle">CONFÉDÉRATION MONDIALE</text>
  <text x="60" y="86" font-family="Helvetica,Arial,sans-serif" font-size="6" font-weight="500" fill="#a7f3d0" text-anchor="middle">ACTIVITÉS SUBAQUATIQUES</text>
  <circle cx="60" cy="60" r="38" fill="none" stroke="#fff" stroke-width="1" opacity="0.4"/>
</svg>`);

export function getFederationLogo(federation) {
  const f = (federation || '').toUpperCase();
  if (f === 'AIDA') return AIDA_LOGO;
  if (f === 'CMAS') return CMAS_LOGO;
  return null;
}

/**
 * Convert any image source (data URL, https URL, or SVG data URL) into a PNG data URL
 * suitable for jsPDF.addImage. Returns a Promise that resolves to {dataUrl, width, height} or null.
 */
export function imageToPngDataURL(src, maxSize = 120) {
  return new Promise((resolve) => {
    if (!src) { resolve(null); return; }
    try {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        try {
          const canvas = document.createElement('canvas');
          let { width, height } = img;
          if (width > maxSize || height > maxSize) {
            const ratio = Math.min(maxSize / width, maxSize / height);
            width = Math.round(width * ratio);
            height = Math.round(height * ratio);
          }
          canvas.width = width || maxSize;
          canvas.height = height || maxSize;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          resolve({ dataUrl: canvas.toDataURL('image/png'), width: canvas.width, height: canvas.height });
        } catch (e) { resolve(null); }
      };
      img.onerror = () => resolve(null);
      img.src = src;
    } catch (e) { resolve(null); }
  });
}
